import { render, staticRenderFns } from "./editMobile.vue?vue&type=template&id=88600ab6&scoped=true"
import script from "./editMobile.vue?vue&type=script&lang=js"
export * from "./editMobile.vue?vue&type=script&lang=js"
import style0 from "./editMobile.vue?vue&type=style&index=0&id=88600ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88600ab6",
  null
  
)

export default component.exports